module.exports = __webpack_public_path__ + "img/pico-cutout-01.7b234430.png";